import { motion } from "framer-motion";
import { renderContent } from "../../../utils/renderContent";

export default function CoffeeBrewingGuide() {
    return (
        <div className="min-h-screen text-stone-800 px-6 py-24">
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="max-w-5xl mx-auto"
            >
                <h1 className="text-xl font-bold text-amber-900 leading-relaxed">
                    بهترین قهوه برای هر روش دم‌آوری
                </h1>

                <p className="mb-8 leading-loose text-gray-300">
                    (راهنمای تخصصی انتخاب دانه قهوه برای طعم بهتر، عصاره‌گیری اصولی و تجربه حرفه‌ای)
                </p>

                <section className="mb-8 text-stone-700 leading-relaxed text-justify text-sm">
                    <p>
                        بسیاری از افراد قهوه‌ای باکیفیت تهیه می‌کنند، اما به دلیل انتخاب نادرست نوع قهوه برای روش دم‌آوری، به نتیجه دلخواه نمی‌رسند.
                        واقعیت این است که هر روش دم‌آوری، الگوی عصاره‌گیری متفاوتی دارد و اگر نوع دانه، درجه رُست و حتی نسبت عربیکا به روبوستا درست انتخاب نشود، طعم نهایی یا بیش‌ازحد تلخ می‌شود یا بی‌رمق و ناپایدار.
                    </p>
                    <p>
                        در این مقاله به‌صورت دقیق و کاربردی بررسی می‌کنیم که برای هر روش دم‌آوری، چه قهوه‌ای بهترین انتخاب است.
                    </p>
                </section>
                <div className=" flex flex-col gap-2 mt-4">
                    {sections.map((section, index) => (
                        <motion.section
                            key={index}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                            className="bg-[#fef9f5] rounded-xl p-4 shadow-md"
                        >
                            <h2 className="text-xl font-semibold text-amber-900 mb-2">{section.title}</h2>
                            <div className="text-stone-800 text-sm leading-relaxed text-justify">
                            {renderContent(section.content)}
                            </div>
                        </motion.section>
                    ))}
                </div>

                <motion.section
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="mt-16 border-t pt-8 leading-loose"
                >
                    <h2 className="text-xl font-bold text-amber-900 leading-relaxed">جمع‌بندی</h2>
                    <p className="text-stone-700 leading-relaxed text-justify text-sm">
                        انتخاب قهوه مناسب برای هر روش دم‌آوری، تفاوت میان یک فنجان معمولی و یک تجربه حرفه‌ای است.
                        شناخت درست رُست، نوع دانه و روش عصاره‌گیری به مصرف‌کننده کمک می‌کند از هر فنجان قهوه بیشترین لذت و کیفیت را دریافت کند.
                    </p>
                </motion.section>
            </motion.div>
        </div>
    );
}

const sections = [
    {
        title: "۱. بهترین قهوه برای موکاپات",
        content: `موکاپات با فشار بخار آب کار می‌کند و عصاره‌گیری نسبتاً قوی دارد؛ بنابراین قهوه‌ای با ساختار مناسب نیاز دارد.

پیشنهاد حرفه‌ای:
 • رُست: مدیوم تا دارک
 • نوع دانه: ترکیب عربیکا و روبوستا
 •   درصد پیشنهادی: ۷۰٪ عربیکا / ۳۰٪ روبوستا - ۵۰٪ عربیکا / ۵۰٪ روبوستا

چرا؟

روبوستا به ایجاد قدرت، کرما و بادی کمک می‌کند و عربیکا عطر و طعم را متعادل نگه می‌دارد.`,
    },
    {
        title: "۲. بهترین قهوه برای فرنچ پرس",
        content: `فرنچ پرس روش غوطه‌وری کامل است و روغن‌های طبیعی قهوه را حفظ می‌کند.

پیشنهاد حرفه‌ای:
 • رُست: مدیوم
 • نوع دانه: عربیکا خالص یا ترکیب سبک
 • آسیاب: درشت

طعم نهایی:

بادی بالا، بافت دهانی قوی و طعمی کامل

مناسب برای:

کسانی که قهوه سنگین و عمیق دوست دارند.`,
    },
    {
        title: "۳. بهترین قهوه برای V60",
        content: `V60 طعم‌های ظریف و ویژگی‌های ذاتی دانه قهوه را به‌خوبی نمایش می‌دهد.

پیشنهاد حرفه‌ای:
 • رُست: لایت تا مدیوم
 • نوع دانه: عربیکا تک‌خاستگاه
 • خاستگاه‌های مناسب: اتیوپی، کنیا، کلمبیا

طعم نهایی:

شفاف، میوه‌ای، اسیدیته متعادل`,
    },
    {
        title: "۴. بهترین قهوه برای کمکس (Chemex)",
        content: `کمکس با فیلتر ضخیم خود طعمی بسیار تمیز ارائه می‌دهد.

پیشنهاد حرفه‌ای:
 • رُست: لایت
 • نوع دانه: عربیکا اسپشیالتی
 • تمرکز بر عطر و شفافیت

مناسب برای:

دوستداران قهوه‌های ملایم و معطر.`,
    },
    {
        title: "۵. بهترین قهوه برای اسپرسو",
        content: `اسپرسو به قهوه‌ای نیاز دارد که تحت فشار بالا تعادل خود را حفظ کند.

پیشنهاد حرفه‌ای:
 • رُست: مدیوم دارک
 • نوع دانه: ترکیب عربیکا و روبوستا
 • درصد پیشنهادی: ۸۰٪ عربیکا / ۲۰٪ روبوستا

نتیجه:

کرمای بهتر، بادی بالا و تلخی کنترل‌شده.`,
    },
    {
        title: "۶. بهترین قهوه برای قهوه‌سازهای خانگی (Drip Coffee Maker)",
        content: `این دستگاه‌ها استخراج یکنواخت و آرام دارند.

پیشنهاد حرفه‌ای:
 • رُست: مدیوم
 • نوع دانه: عربیکا
 • آسیاب: متوسط`,
    },
    {
        title: "۷. اگر کافئین بالاتر می‌خواهید، چه قهوه‌ای انتخاب کنید؟",
        content: `برای افزایش کافئین، به این عوامل توجه کنید:
 • استفاده از روبوستا یا ترکیب‌های روبوستا
 • دم‌آوری طولانی‌تر (فرنچ پرس، قهوه دمی)
 • حجم فنجان بیشتر

نکته علمی: رُست تیره الزاماً کافئین بیشتری ندارد.`,
    },
];
